import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { userManager } from '../../../../setup/auth/authService';
import { useTranslation } from 'react-i18next';
import { useToast } from '../../layout/components/ToastContext';

const CallbackPage = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { showToast } = useToast();

  useEffect(() => {
    const hasShown = localStorage.getItem('toastShown');

    userManager.signinRedirectCallback()
      .then(() => {
        if (!hasShown) {
          //showToast(t('LoggedIn'), 'success');
          localStorage.setItem('toastShown', 'true');
        }
        navigate('/');
      })
      .catch(error => {
        console.log(t('CallbackError', { error: String(error) }));
        showToast(t('CallbackError', { error: String(error) }), 'error');
        
        navigate('/');
      });
  }, [navigate, showToast, t]);

  
  return <p>{t('SigningIn')}</p>;
};

export default CallbackPage;
